module.exports = __webpack_public_path__ + "img/c05_unittechaquiliferchampion_Normal_ua.4d6a0f26.webp";